import {
  PassportTemplate as Data,
  PassportTemplateCollection as Collection,
} from '@/typings/api/Passport'
import { BaseApiAuth } from '@/api/BaseApiAuth'


export class PassportTemplatesApi extends BaseApiAuth<Data, Collection> {
    protected readonly endpoint = 'ate/passport-templates';
}
